<div class="sin-datos" [class.compacto]="compacto">

  <div class="icono-wrap">
    <!-- Dos ondas desfasadas: dan la sensación de "buscando y no hay nada acá",
         en vez de una pantalla que se quedó colgada -->
    <span class="onda"></span>
    <span class="onda onda-2"></span>
    <span class="disco"></span>
    <mat-icon>{{ icono }}</mat-icon>
  </div>

  <p class="mensaje">{{ mensaje }}</p>

  <p class="detalle" *ngIf="detalle">{{ detalle }}</p>

  <button mat-stroked-button color="primary" class="boton-accion" *ngIf="textoAccion"
    (click)="onAccion()">
    <mat-icon>{{ iconoAccion }}</mat-icon>
    {{ textoAccion }}
  </button>

</div>
